import { faStar as falStar } from '@fortawesome/pro-light-svg-icons/faStar'
import { faStar as fasStar } from '@fortawesome/pro-solid-svg-icons/faStar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import styles from './FavoriteButton.scss'

export interface FavoriteButtonProps {
  selected: boolean,
  onClick: () => void,
}

const FavoriteButton = (props) => (
  <button
    className={styles.favorite_button}
    onClick={props.onClick}
  >
    <FontAwesomeIcon
      icon={props.selected ? fasStar : falStar}
      size="1x"
      className={props.selected ? styles.selected : ''}
    />
  </button>
)

export default FavoriteButton
